import { techLogos } from "./assets";
export const mernExpertise = [
  [
    {
      key: 0,
      title: "MongoDB",
      logoImg: techLogos.mongodb,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "ExpressJs",
      logoImg: techLogos.express,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 2,
      title: "ReactJs",
      logoImg: techLogos.react,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 3,
      title: "NodeJs",
      logoImg: techLogos.node,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
];

export const frontEndExpertise = [
  [
    {
      key: 0,
      title: "JavaScript",
      logoImg: techLogos.javascript,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "ReactJs (Hooks)",
      logoImg: techLogos.react,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "NextJs",
      logoImg: techLogos.nextjs,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "HTML5",
      logoImg: techLogos.html5,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "CSS3",
      logoImg: techLogos.css3,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 2,
      title: "Tailwind CSS",
      logoImg: techLogos.tailwind,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "Bootstrap",
      logoImg: techLogos.bootstrap,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "Mui",
      logoImg: techLogos.mui,
      dataAOS: "fade-up",
    },
  ],
  [
    {
      key: 0,
      title: "Basic PS / Figma",
      logoImg: techLogos.figma,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
];

export const toolsAndLibraries = [
  [
    {
      key: 0,
      title: "Redux",
      logoImg: techLogos.redux,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "React Query",
      logoImg: techLogos.reactQuery,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "Bootstrap (React)",
      logoImg: techLogos.bootstrap,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "SCSS (Sass)",
      logoImg: techLogos.sass,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "Vercel / Netlify / Heroku",
      logoImg: techLogos.heroku,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 2,
      title: "Git/Hub",
      logoImg: techLogos.git,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
  [
    {
      key: 0,
      title: "Jest / Testing Library",
      logoImg: techLogos.jest,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
    {
      key: 1,
      title: "Google Firebase",
      logoImg: techLogos.firebase,
      dataAOS: "fade-up",
    },
  ],
  [
    {
      key: 2,
      title: "WordPress",
      logoImg: techLogos.wordpress,
      dataAOS: "fade-up",
      dataAOS_delay: 500,
    },
  ],
];
